import { Fragment } from "react/jsx-runtime";
import Physician from "../../../Physician/Models/Physician";
import { Col, Row } from "react-bootstrap";


interface IProps{
    physician: Physician;
}

export default function CCBlockSummaryAnnualFeesNotMeeting(props: IProps) {
    const nbsp = '\u00A0';

    var endYearOfCurrentBlock = props.physician.currentCCEnrollment.currentCCBlock.endYear;
    var index = props.physician.currentCCEnrollment.ccBlocks.findIndex(_ => _.endYear === endYearOfCurrentBlock);
    var nextBlock = props.physician.currentCCEnrollment.ccBlocks[index + 1];
    var dueDate = new Date(nextBlock.endDate);

    const determineBlockYears = () => {
        var blockYears = new Array<number>();
        
        for (var year = props.physician.currentCCEnrollment.currentCCBlock.startYear; year <= props.physician.currentCCEnrollment.currentCCBlock.endYear; year++) {
            blockYears.push(year);
        }
        return blockYears;
    }

    const determineFutureBlockYears = () => {
        var nextBlockYears = new Array<number>();
        
        for (var year = nextBlock.startYear; year <= nextBlock.endYear; year++) {
            nextBlockYears.push(year);
        }
        return nextBlockYears;
    }

    var blockYears = determineBlockYears();
    var nextBlockYears = determineFutureBlockYears();

    const isPaid = (year: number) => {
        var annualFee = props.physician.currentCCEnrollment.currentCCBlock.ccAnnualFees.find(_ => _.year == year)

        if(annualFee != null){
            if (annualFee.isPaid) return true;
            if (annualFee.isWaived) return true;
    
            return false;
        }
    }

    return (
        <Fragment>
            <div className="ccenrollment-summary-padding">
                <div className="ccenrollment-summary-border" style={{background: '#fff'}}>
                    <Row className="ccenrollment-summary-cert">
                        <Col>
                            <Row className="ccenrollment-certificate-header">
                                <Col>
                                    <div className="mb-0 font-weight-bolder card-title pp-font-size-small text-center">Annual Fees</div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="text-center">
                            <div className="las la-clock la-3x"></div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="pp-font-size-small text-center">
                                <span>Due by {dueDate.getMonth()+1}/{dueDate.getDate()}/{dueDate.getFullYear()}</span>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div>
                                {nbsp}
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="pp-font-size-small"style={{paddingLeft: 20}}>
                                <b>{ blockYears[0] }-{ blockYears[2] }</b>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="pr-md-0">
                            <div className="pp-font-size-smaller text-center">
                                <span><b>{blockYears[0]}</b></span>
                            </div>
                        </Col>
                        <Col className="px-md-0">
                            <div className="pp-font-size-smaller text-center">
                                <span><b>{blockYears[1]}</b></span>
                            </div>
                        </Col>
                        <Col className="pl-md-0">
                            <div className="pp-font-size-smaller text-center">
                                <span><b>{blockYears[2]}</b></span>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="pr-md-0">
                            <div>
                                {isPaid(blockYears[0]) == true ? 
                                    <div className="text-success pp-font-size-small text-center"><div className="las la-check"></div></div>
                                    :
                                    <div className="text-danger pp-font-size-small text-center"><div className="las la-times"></div></div>
                                }
                            </div>
                        </Col>
                        <Col className="px-md-0">
                            <div>
                                {isPaid(blockYears[1]) == true ? 
                                    <div className="text-success pp-font-size-small text-center"><div className="las la-check"></div></div>
                                    :
                                    <div className="text-danger pp-font-size-small text-center"><div className="las la-times"></div></div>
                                }
                            </div>
                        </Col>
                        <Col className="pl-md-0">
                            <div>
                                {isPaid(blockYears[2]) == true ? 
                                    <div className="text-success pp-font-size-small text-center"><div className="las la-check"></div></div>
                                    :
                                    <div className="text-danger pp-font-size-small text-center"><div className="las la-times"></div></div>
                                }
                            </div>
                        </Col>
                    </Row>
                    <hr className="pp-horizontalrule-padding"/>
                    <Row>
                        <Col>
                            <div className="pp-font-size-small" style={{paddingLeft: 20}}>
                                <b>{ nextBlockYears[0] }-{ nextBlockYears[2] }</b>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="pr-md-0">
                            <div className="pp-font-size-smaller text-center">
                                <span><b>{nextBlockYears[0]}</b></span>
                            </div>
                        </Col>
                        <Col className="px-md-0">
                            <div className="pp-font-size-smaller text-center">
                                <span><b>{nextBlockYears[1]}</b></span>
                            </div>
                        </Col>
                        <Col className="pl-md-0">
                            <div className="pp-font-size-smaller text-center">
                                <span><b>{nextBlockYears[2]}</b></span>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="pr-md-0">
                            <div>
                                <div className="text-danger pp-font-size-small text-center"><div className="las la-times"></div></div>
                            </div>
                        </Col>
                        <Col className="px-md-0">
                            <div>
                                <div className="text-danger pp-font-size-small text-center"><div className="las la-times"></div></div>
                            </div>
                        </Col>
                        <Col className="pl-md-0">
                            <div>
                                <div className="text-danger pp-font-size-small text-center"><div className="las la-times"></div></div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="pp-font-size-smallest">
                                {nbsp}
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </Fragment>
    );
}